import React, { useEffect, useState } from 'react';
import styles from './AdminExerciseSingle.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { exerciseSingle } from '../../../redux/actions/app/exerciseSingle';
import { resetExerciseEdit, resetExerciseSingle } from '../../../redux/slices/app.slice';
import { useDispatch } from 'react-redux';
import { exerciseEdit } from '../../../redux/actions/app/exerciseEdit';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../components/admin/Loading/Loading';

const AdminExerciseSingle = () => {
  const data = [
    [
      {
        label: 'Видео',
        type: 'upload',
        name: 'linkVideo',
        width: '90%',
      },
      [
        {
          label: 'Название',
          type: 'text',
          name: 'name',
        },
        { label: 'Порядок', type: 'number', name: 'order' },
        { label: 'Описание', type: 'textarea', name: 'desc', required: false },
      ],
    ],
  ];
  const [fields, setFields] = useState([]);
  const onFormatData = ({ exercise: { name, order, desc, linkVideo } }) => {
    // const fields = [
    //   [
    //     {
    //       label: 'Страна',
    //       type: 'select',
    //       name: 'citizenshipId',
    //       options: citizenships?.map((club) => ({ value: club?.id, label: club?.name })),
    //     },
    //     {
    //       label: 'Город',
    //       type: 'select',
    //       name: 'cityId',
    //       options: cities?.map((club) => ({ value: club?.id, label: club?.name })),
    //     },
    //   ],
    //   [
    //     {
    //       label: 'Домашний клуб',
    //       type: 'select',
    //       name: 'clubId',
    //       options: clubs?.map((club) => ({ value: club?.id, label: club?.name })),
    //     },
    //     {
    //       label: 'Уровень игры',
    //       type: 'select',
    //       name: 'gradeId',
    //       options: grades?.map((club) => ({ value: club?.id, label: club?.name })),
    //     },
    //   ],
    //   [
    //     {
    //       label: 'Телефон',
    //       type: 'number',
    //       name: 'phone',
    //       format: '+7 (###) ### ## ##',
    //     },
    //     {
    //       required: false,
    //       label: 'Email',
    //       type: 'text',
    //       name: 'email',
    //       rules: {
    //         pattern: {
    //           value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    //           message: 'Неверный формат почты',
    //         },
    //       },
    //     },
    //   ],
    // ];
    setFields([...data]);
    return { name, order, desc, linkVideo };
  };
  const deleteProps = { successText: 'Пользователь удален', confirmTitle: `Вы уверены что хотите удалить пользователя`, status: 'DELETED' };
  const blockProps = { successText: 'Пользователь заблокирован', confirmTitle: `Вы уверены что хотите заблокировать пользователя`, status: 'BLOCKED' };
  const unblockProps = { successText: 'Пользователь разблокирован', confirmTitle: `Вы уверены что хотите разблокировать пользователя`, status: 'ACTIVE' };
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    exerciseEdit: { data: exerciseEditData, loading: exerciseEditLoading },
  } = useSelector((state) => state.app);
  const navigate = useNavigate();
  useEffect(() => {
    if (exerciseEditData) {
      toast.success('Упражнение обновлено');
      navigate('/admin/exercises');
      dispatch(resetExerciseEdit());
    }
  }, [exerciseEditData]);

  return (
    <>
      <AdminSinglePage
        isBlock={false}
        isDelete={false}
        onSubmit={(data) => {
          console.log(data);

          dispatch(exerciseEdit({ id, ...data }));
        }}
        reset={resetExerciseSingle}
        fetch={exerciseSingle}
        sliceName={'app'}
        actionName={'exerciseSingle'}
        onFormatData={onFormatData}
        fields={fields}
        isSave
        pathList="/admin/exercises"
        deleteProps={deleteProps}
        blockProps={blockProps}
        unblockProps={unblockProps}
        propName={'exercise'}
        type={'USER'}
      />
      {exerciseEditLoading && <Loading />}
    </>
  );
};

export default AdminExerciseSingle;
